import styled from 'styled-components'

export const Wrapper = styled.div`
  canvas {
    height: 16rem !important;
    width: 16rem !important;
  }
`
